import Loadable from 'react-loadable'

const Info = Loadable({
  loader: () => import(/* webpackChunkName: "info" */ './components/Info'),
  loading: () => null,
})

const SubInfo = Loadable({
  loader: () => import(/* webpackChunkName: "subinfo" */ './components/SubInfo'),
  loading: () => null,
})

const InfoDetail = Loadable({
  loader: () => import(/* webpackChunkName: "infodetail" */ './components/InfoDetail'),
  loading: () => null,
})

export {
  Info,
  SubInfo,
  InfoDetail,
}



// WEBPACK FOOTER //
// ./src/routes/Info/index.js